module.exports = __webpack_public_path__ + "static/media/lock.c83c6d54.svg";